export default {
    icon_3: drawIcon_3_Model, /*3列图标icon 绘制 模块*/
    icon_4: drawIcon_4_Model, /*4列图标icon 绘制 模块*/
    icon_5: drawIcon_5_Model  /*5列图标icon 绘制 模块*/
}

/**
 * 3列图标模块(每6个图标分页)
 * 
 * @param  {Array} data        
 * 详见pageMock.js文件中"modelType":"icon_3"的infoList数组
 * 
 * @return {String}
 * 拼接后的字符串     
 */
function drawIcon_3_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'icon-model'
    return `<section class="${cName} icon-model-3">
				<ul class="swiper-wrapper">
					${data.infoList.map((item, index)=>`
						${index % 6 === 0 ? '<li class="swiper-slide">' : ''}
						<a class="icon-box clickreport-luna-icon clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
							<img src="${item.imgUrl}" />
							<p>${item.txt}</p>
						</a>
						${(index !== 0 && index % 6 === 5) ? '</li>' : ''}
					`).join('')}
				</ul>
				<div class="swiper-pagination"></div>
			</section>`
}

/**
 * 4列图标模块(每8个图标分页)
 * 
 * @param  {Array} data        
 * 详见pageMock.js文件中"modelType":"icon_4"的infoList数组
 * 
 * @return {String}
 * 拼接后的字符串     
 */
function drawIcon_4_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'icon-model'
    return `<section class="${cName} icon-model-4">
				<ul class="swiper-wrapper">
					${data.infoList.map((item, index)=>`
						${index % 8 === 0 ? '<li class="swiper-slide">' : ''}
						<a class="icon-box clickreport-luna-icon clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
							<img src="${item.imgUrl}" />
							<p>${item.txt}</p>
						</a>
						${(index !== 0 && index % 8 === 7) ? '</li>' : ''}
					`).join('')}
				</ul>
				<div class="swiper-pagination"></div>
			</section>`
}


/**
 * 5列图标模块(每10个图标分页)
 * 
 * @param  {Array} data        
 * 详见pageMock.js文件中"modelType":"icon_5"的infoList数组
 * 
 * @return {String}
 * 拼接后的字符串     
 */
function drawIcon_5_Model(data,cName,moduleIndex){
    cName = cName ? cName : 'icon-model'
    return `<section class="${cName} icon-model-5">
				<ul class="swiper-wrapper">
					${data.infoList.map((item, index)=>`
						${index % 10 === 0 ? '<li class="swiper-slide">' : ''}
						<a class="icon-box clickreport clickreport-luna-icon" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
							<img src="${item.imgUrl}" />
							<p>${item.txt}</p>
						</a>
						${(index !== 0 && index % 10 === 9) ? '</li>' : ''}
					`).join('')}
				</ul>
				<div class="swiper-pagination"></div>
			</section>`
}
